import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Configuration } from 'src/app/models/shared/configuration.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  public static config: Configuration;

  private url = environment.production ? '/assets/config/settings.prod.json' : '/assets/config/settings.json';

  constructor(private http: HttpClient) { }

  async loadConfig(): Promise<void> {
    try {
      ConfigurationService.config = await firstValueFrom<Configuration>(
        this.http.get<Configuration>(this.url)
      );
    } catch (err) {
      console.error('Could not load config file', err);
    }
  }

}
